import type { HvacSystemValues } from '../components/HvacSystemFields';
import type { PlumbingSystemValues } from '../components/PlumbingSystemFields';

const KEY_PREFIX = 'inspectionReportDraft_';

const buildKey = (homeInspectionJobId: string) => `${KEY_PREFIX}${homeInspectionJobId}`;

/** Serializable form fields (matches InspectionFormValues shape). */
export interface InspectionReportDraftPayload {
  savedAt: string;
  formValues: Record<string, string | boolean>;
  hvacSystems: HvacSystemValues[];
  plumbingSystems: PlumbingSystemValues[];
}

export function loadDraft(homeInspectionJobId: string): InspectionReportDraftPayload | null {
  try {
    const raw = localStorage.getItem(buildKey(homeInspectionJobId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as InspectionReportDraftPayload;
    if (!parsed || typeof parsed !== 'object' || !parsed.formValues) return null;
    return parsed;
  } catch (error) {
    console.error('Failed to load inspection report draft:', error);
    return null;
  }
}

export function saveDraft(homeInspectionJobId: string, payload: InspectionReportDraftPayload): void {
  try {
    localStorage.setItem(buildKey(homeInspectionJobId), JSON.stringify(payload));
  } catch (error) {
    console.error('Failed to save inspection report draft:', error);
  }
}

export function clearDraft(homeInspectionJobId: string): void {
  try {
    localStorage.removeItem(buildKey(homeInspectionJobId));
  } catch (error) {
    console.error('Failed to clear inspection report draft:', error);
  }
}
